import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import useQuery from '@/hooks/useQuery';
import { extractToTokenNameByName } from '@/utils/regex';

interface MenuItem {
  label: string;
  isActive?: boolean;
  onClick: () => void;
}

export function useMenus() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const query = useQuery();
  const { t } = useTranslation();

  const isCampaignPage = pathname.startsWith('/campaign') || pathname.startsWith('/leaderboard');

  const menus: MenuItem[] = useMemo(() => {
    if (isCampaignPage) {
      return [
        {
          label: t('header.campaign'),
          isActive: pathname === '/campaign',
          onClick: () => {
            navigate(`/campaign?${query.toString()}`);
          },
        },
        {
          label: t('header.leaderboard'),
          isActive: pathname === '/leaderboard',
          onClick: () => {
            navigate(`/leaderboard?${query.toString()}`);
          },
        },
      ];
    }

    return [
      {
        label: t('header.restake'),
        isActive: pathname === '/',
        onClick: () => {
          navigate(`/?${query.toString()}`);
        },
      },
      {
        label: t('header.portfolio'),
        isActive: pathname === '/portfolio',
        onClick: () => {
          const newQuery = new URLSearchParams();
          const symbol = query.get('symbol');
          const chain = query.get('chain');
          if (chain) {
            newQuery.set('chain', chain);
          } else if (symbol) {
            newQuery.set('symbol', extractToTokenNameByName(symbol));
          }
          navigate(`/portfolio?${newQuery.toString()}`);
        },
      },
      {
        label: t('header.docs'),
        isActive: false,
        onClick: () => {
          window.open('https://docs.allstake.org/', '_blank');
        },
      },
    ];
  }, [pathname, isCampaignPage, query, t, navigate]);

  return {
    menus,
  };
}
